import { axiosInstance } from '~/services/fetchServiceV2';

import { useDedupeMutation } from '../common';

/** @category useCommuteAfterContract */
type TypeCommuteAfterContractParams = {
  /** 연장 근무 희망 여부 */
  overWorkWishedStatus: string;
};

/** @category useCommuteAfterContract */
type TypeCommuteAfterContractResponse = {
  code: string;
  message: string;
  data: {
    /** 출근 QR 코드 문자열 */
    qrCode: string;
    commute: {
      /** 출근 아이디 */
      commuteId: number;
      /** 작업자 계정 식별번호 */
      laborAccountId: number;
      /** 작업자 계정 로그인 ID */
      userId: string;
      /** 근무일 */
      workDate: string;
      /** 근무시간 */
      workingTime: number;
      /** 근무시작일시 */
      startWorkTime: string;
      /** 근무종료일시 */
      endWorkTime: string;
      /** 클러스터 */
      cluster: string;
      /** 센터 */
      center: string;
    };
  };
};

/**
 * @description 아르바이트 작업자가 계약 정보를 가지고 출근을 처리하는 api 요청에 사용되는 커스텀 훅
 */
export const useCommuteAfterContract = () => {
  const [requestCommuteAfterContract] = useDedupeMutation<
    TypeCommuteAfterContractParams,
    TypeCommuteAfterContractResponse
  >({
    mutationFn: (params: TypeCommuteAfterContractParams) => {
      const endpoint = '/commutes/short-start';
      return axiosInstance.post<TypeCommuteAfterContractResponse>(endpoint, params);
    },
  });

  return requestCommuteAfterContract;
};
